export const preloaderImage = image => {
  return new Promise(resolve => {
    const url = window.URL.createObjectURL(image);
    const img = new Image();

    img.src = url;
    img.onload = () => {
      resolve(url);
    };
  });
};



// WEBPACK FOOTER //
// ./src/utils/preloaderImage.js